<template>
  <div class="page-layout">
    <HeaderAnth
      :searchQuery="searchQuery"
      :isAuthenticated="isAuthenticated"
      @buscar="buscarProductos"
      @cerrar-sesion="cerrarSesion"
    />

    <div class="todos-productos-container">
      <div class="page-header">
        <h1>{{ searchQuery ? 'Resultados de búsqueda' : 'Todos los Productos' }}</h1>
        <p class="breadcrumb">
          <router-link to="/home">Inicio</router-link> /
          <span v-if="searchQuery">Búsqueda: "{{ searchQuery }}"</span>
          <span v-else>Productos</span>
        </p>
        <!-- Indicador de búsqueda activa -->
        <div v-if="searchQuery" class="search-indicator">
          <span class="search-tag">
            Buscando: <strong>{{ searchQuery }}</strong>
            <button @click="limpiarBusqueda" class="clear-search-btn" title="Limpiar búsqueda">×</button>
          </span>
        </div>
      </div>

      <div class="productos-layout">
        <!-- Panel lateral de filtros -->
        <aside class="filtros-sidebar">
          <div class="filtros-header">
            <h2>Filtros</h2>
            <button @click="limpiarFiltros" class="limpiar-btn">Limpiar filtros</button>
          </div>

          <!-- Filtro por Marca -->
          <div class="filtro-seccion">
            <h3>Marca</h3>
            <input
              v-model="busquedaMarca"
              type="text"
              class="filtro-busqueda"
              placeholder="Buscar marca..."
            />
            <div class="filtro-opciones">
              <label v-for="marca in marcasFiltradas" :key="marca" class="checkbox-label">
                <input
                  type="checkbox"
                  :value="marca"
                  v-model="filtros.marcas"
                  @change="aplicarFiltros"
                />
                <span>{{ marca }}</span>
              </label>
              <span v-if="marcasFiltradas.length === 0" class="no-opciones">Sin resultados</span>
            </div>
          </div>

          <!-- Filtro por Categoría -->
          <div class="filtro-seccion" v-if="categoriasDisponibles.length > 0">
            <h3>Categoría</h3>
            <input
              v-model="busquedaCategoria"
              type="text"
              class="filtro-busqueda"
              placeholder="Buscar categoría..."
            />
            <div class="filtro-opciones">
              <label v-for="categoria in categoriasFiltradas" :key="categoria" class="checkbox-label">
                <input
                  type="checkbox"
                  :value="categoria"
                  v-model="filtros.categorias"
                  @change="aplicarFiltros"
                />
                <span>{{ categoria }}</span>
              </label>
              <span v-if="categoriasFiltradas.length === 0" class="no-opciones">Sin resultados</span>
            </div>
          </div>

          <!-- Filtro por Medida -->
          <div class="filtro-seccion">
            <h3>Medida</h3>
            <input
              v-model="busquedaMedida"
              type="text"
              class="filtro-busqueda"
              placeholder="Buscar medida..."
            />
            <div class="filtro-opciones">
              <label v-for="medida in medidasFiltradas" :key="medida" class="checkbox-label">
                <input
                  type="checkbox"
                  :value="medida"
                  v-model="filtros.medidas"
                  @change="aplicarFiltros"
                />
                <span>{{ medida }}</span>
              </label>
              <span v-if="medidasFiltradas.length === 0" class="no-opciones">Sin resultados</span>
            </div>
          </div>

          <!-- Filtro por Rango de Precio -->
          <div class="filtro-seccion">
            <h3>Precio</h3>
            <div class="precio-inputs">
              <input
                type="number"
                v-model.number="filtros.precioMin"
                placeholder="Mínimo"
                @input="aplicarFiltros"
                class="precio-input"
              />
              <span class="precio-separador">-</span>
              <input
                type="number"
                v-model.number="filtros.precioMax"
                placeholder="Máximo"
                @input="aplicarFiltros"
                class="precio-input"
              />
            </div>
            <div class="precio-info">
              <span>Rango: ${{ precioMinimo }} - ${{ precioMaximo }}</span>
            </div>
          </div>

          <!-- Filtro por Stock -->
          <div class="filtro-seccion">
            <h3>Disponibilidad</h3>
            <div class="filtro-opciones">
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  v-model="filtros.soloDisponibles"
                  @change="aplicarFiltros"
                />
                <span>Solo con stock</span>
              </label>
            </div>
          </div>
        </aside>

        <!-- Grid de productos -->
        <div class="productos-main">
          <div class="productos-toolbar">
            <div class="resultados-info">
              <span>{{ productosFiltrados.length }} productos encontrados</span>
            </div>
            <div class="vista-opciones">
              <button 
                :class="['vista-btn', { active: vistaActual === 'cuadricula' }]" 
                @click="vistaActual = 'cuadricula'"
                title="Vista Cuadrícula"
              >
                ⊞
              </button>
              <button 
                :class="['vista-btn', { active: vistaActual === 'lista' }]" 
                @click="vistaActual = 'lista'"
                title="Vista Lista"
              >
                ☰
              </button>
            </div>
            <div class="ordenar-section">
              <label>Ordenar por:</label>
              <select v-model="ordenamiento" @change="aplicarOrdenamiento" class="ordenar-select">
                <option value="relevancia">Relevancia</option>
                <option value="precio-asc">Precio: menor a mayor</option>
                <option value="precio-desc">Precio: mayor a menor</option>
                <option value="nombre-asc">Nombre: A-Z</option>
                <option value="nombre-desc">Nombre: Z-A</option>
              </select>
            </div>
          </div>

          <div v-if="cargando" class="loading">
            <p>Cargando productos...</p>
          </div>

          <div v-else-if="productosFiltrados.length === 0" class="no-productos">
            <p>No se encontraron productos con los filtros seleccionados.</p>
          </div>

          <div v-else :class="['productos-grid', vistaActual === 'lista' ? 'vista-lista' : 'vista-cuadricula']">
            <div
              v-for="producto in productosPaginados"
              :key="producto.codigo"
              class="producto-card"
              @click="verDetalle(producto.codigo)"
            >
              <div class="producto-imagen">
                <img 
                  :src="producto.imagen_url || '/placeholder_product.jpg'" 
                  :alt="producto.producto"
                  @error="handleImageError"
                  loading="lazy"
                />
                <span v-if="parseInt(producto.existenciaTotal) === 0" class="badge sin-stock">Sin Stock</span>
                <span v-else-if="parseInt(producto.existenciaTotal) < 3" class="badge poco-stock">Pocas unidades</span>
              </div>
              <div class="producto-info">
                <span v-if="producto.marca" class="marca-tag">{{ producto.marca }}</span>
                <span class="codigo-tag">Cód: {{ producto.codigo }}</span>
                <h3>{{ producto.producto }}</h3>
                <p class="descripcion" v-if="producto.medida">Medida: {{ producto.medida }}</p>
                <div class="producto-footer">
                  <div v-if="isAuthenticated" class="precio-info">
                    <p class="precio">${{ formatearPrecio(producto.costoTotal) }}</p>
                    <p style="font-size: 0.75em; color: #999; margin: 0;">incluido IVA</p>
                  </div>
                  <p v-else class="precio">Inicia sesión para ver precio</p>
                  <p class="stock" :class="{ 'sin-stock': parseInt(producto.existenciaTotal) === 0, 'pocas-unidades': parseInt(producto.existenciaTotal) > 0 && parseInt(producto.existenciaTotal) < 3 }">
                    {{ obtenerTextoStock(parseInt(producto.existenciaTotal)) }}
                  </p>
                </div>
                <div class="producto-acciones">
                  <button 
                    v-if="parseInt(producto.existenciaTotal) > 0"
                    @click.stop="agregarAlCarrito(producto)" 
                    class="agregar-btn"
                    title="Agregar al carrito"
                  >
                    🛒 Agregar
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Paginación -->
          <div v-if="totalPaginas > 1" class="paginacion">
            <button 
              @click="cambiarPagina(paginaActual - 1)" 
              :disabled="paginaActual === 1"
              class="pagina-btn"
            >
              ← Anterior
            </button>

            <div class="paginas-numeros">
              <template v-for="(pagina, index) in paginasVisibles" :key="index">
                <button
                  v-if="pagina !== '...'"
                  @click="cambiarPagina(pagina)"
                  :class="['pagina-numero-btn', { activa: pagina === paginaActual }]"
                >
                  {{ pagina }}
                </button>
                <span v-else class="pagina-ellipsis">...</span>
              </template>
            </div>

            <button 
              @click="cambiarPagina(paginaActual + 1)" 
              :disabled="paginaActual === totalPaginas"
              class="pagina-btn"
            >
              Siguiente →
            </button>

            <div class="pagina-info-container">
              <span class="pagina-info">Página {{ paginaActual }} de {{ totalPaginas }}</span>
              <div class="ir-a-pagina">
                <label>Ir a:</label>
                <input
                  type="number"
                  v-model.number="paginaInput"
                  @keyup.enter="irAPaginaInput"
                  :min="1"
                  :max="totalPaginas"
                  placeholder="#"
                  class="pagina-input"
                />
                <button @click="irAPaginaInput" class="btn-ir" title="Ir a página">
                  →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ContactoAsesor />
    <FooterAnth />
  </div>
</template>

<script src="./TodosLosProductos.js"></script>
<style src="./TodosLosProductos.css"></style>
